export const PREF_KEY = {
    SHOW_REPORTING: 'show_reporting',
    FORECAST_RANGE_YEARS: 'forecast_range_years',
    HIGHLIGHT_EXCEPTIONS_BY_DEFAULT: 'highlight_exceptions_by_default',
};

export const PREF_DEFAULT = {
    [PREF_KEY.SHOW_REPORTING]: true,
    [PREF_KEY.FORECAST_RANGE_YEARS]: 3,
    [PREF_KEY.HIGHLIGHT_EXCEPTIONS_BY_DEFAULT]: true,
};

export const PREF_LABEL = {
    [PREF_KEY.SHOW_REPORTING]: 'Show Reporting',
    [PREF_KEY.FORECAST_RANGE_YEARS]: 'Forecast Range (Years)',
    [PREF_KEY.HIGHLIGHT_EXCEPTIONS_BY_DEFAULT]: 'Highlight Exceptions',
};

export const PREF_TYPE = {
    [PREF_KEY.SHOW_REPORTING]: 'boolean',
    [PREF_KEY.FORECAST_RANGE_YEARS]: 'number',
    [PREF_KEY.HIGHLIGHT_EXCEPTIONS_BY_DEFAULT]: 'boolean',
};

export const PREF_ELEMENT_TYPE = {
    [PREF_KEY.SHOW_REPORTING]: 'toggle',
    [PREF_KEY.FORECAST_RANGE_YEARS]: 'range',
    [PREF_KEY.HIGHLIGHT_EXCEPTIONS_BY_DEFAULT]: 'toggle',
};

export const PREF_DESCRIPTION = {
    [PREF_KEY.SHOW_REPORTING]: 'Show reporting charts and tables in dashboard',
    [PREF_KEY.FORECAST_RANGE_YEARS]: 'Budget forecast range in years from start date to last day of final year',
    [PREF_KEY.HIGHLIGHT_EXCEPTIONS_BY_DEFAULT]: 'Highlight transaction instance exceptions by default',
};

export const PREF_OPTIONS = {
    [PREF_KEY.SHOW_REPORTING]: null,
    [PREF_KEY.FORECAST_RANGE_YEARS]: null,
    [PREF_KEY.HIGHLIGHT_EXCEPTIONS_BY_DEFAULT]: null,
};

export const PREFERENCES = [
    PREF_KEY.SHOW_REPORTING,
    PREF_KEY.FORECAST_RANGE_YEARS,
    PREF_KEY.HIGHLIGHT_EXCEPTIONS_BY_DEFAULT,
];